export default "__VITE_ASSET__jjVY9g0d__"